import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

import store from './redux/store'
import { Provider, } from 'react-redux';

import PublicRoute from './utils/PublicRoute';
import PrivateRoute from './utils/PrivateRoute';

import CookieBanner from './components/cookieBanner/CookieBanner';

/* layout */
import HeaderBar from './layouts/headerbar/HeaderBar';
import FooterBar from './layouts/footerbar/FooterBar';
import MainWrapper from './layouts/mainwrapper/MainWrapper';

/* Page */
import Accueil from './pages/accueil/Accueil';
import Loggin from './pages/loggin/Loggin';
import Equipe from './pages/equipe/Equipe';
import Contact from './pages/contact/Contact';
import Groupes from './pages/groupes/Groupes';
import Agenda from './pages/agenda/Agenda';
import EvenementDetail from './pages/agenda/EvenementDetail';

import NotFound from './pages/notFound/NotFound';
import CarteCadeau from './pages/carteCadeau/CarteCadeau';
import Reservation from './pages/reservation/Reservation';
import Console from './pages/administration/Console'
import CGV from './pages/cgv/CGV';
import ManageReservation from './pages/reservation/ManageReservation';


function App() {
  return (
    <div className="bg-white">
      <Provider store={store}>


      <BrowserRouter>
          <CookieBanner />
          <HeaderBar />
        <Routes>
          <Route path='/' element={<MainWrapper position='fixed'><Accueil/></MainWrapper>}></Route>
          <Route path='/equipe' element={<MainWrapper><Equipe/></MainWrapper>}></Route>
          <Route path='/contact' element={<MainWrapper><Contact/></MainWrapper>}></Route>
          <Route path='/cadeau' element={<MainWrapper><CarteCadeau /></MainWrapper>}></Route>
          <Route path='/groupes' element={<MainWrapper><Groupes/></MainWrapper>}></Route>
          <Route path='/agenda' element={<MainWrapper><Agenda/></MainWrapper>}></Route>
          <Route path='/agenda/evenement/:id' element={<MainWrapper><EvenementDetail/></MainWrapper>}></Route>

          <Route path='/reservations' element={<MainWrapper><Reservation /></MainWrapper>}></Route>
          <Route path='/reservation/link/:creneauId' element={<MainWrapper><ManageReservation /></MainWrapper>}></Route>
          <Route path='/cgv' element={<MainWrapper><CGV /></MainWrapper>}></Route>
          <Route path='/login' element={<MainWrapper>
            <Loggin /></MainWrapper>}></Route>
          <Route path='/console' element={<Navigate to="/administration" replace />} />
          <Route path="/administration" element={<PrivateRoute><MainWrapper>
            <Console></Console></MainWrapper></PrivateRoute>}>
          </Route>
          <Route path="*" element={<MainWrapper><NotFound /></MainWrapper>} />
        </Routes>
      <FooterBar/>

      </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
